import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentTransportOrderSapDeliveriesFacade } from './shipment-transport-order-sap-deliveries.facade';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderSapDeliveriesGuard {
  constructor(private shipmentTransportOrderSapDeliveriesFacade: ShipmentTransportOrderSapDeliveriesFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.shipmentTransportOrderSapDeliveriesFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderSapDeliveriesFacade);
  }
}
